import { useEffect, useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../store';
import { FilterConfigDto } from '../store/states/filterTypes';
import { createGlobalFilterSearchParamKey } from '../utils/globalSearchHelpers';

import { presetSelectionFromUrl } from './presetFilterSelectionForFilter';
import { useSearchParamsByKeys } from './useSearchParamsByKey';

type UsePresetGlobalFiltersFromUrlParams = {
  config?: FilterConfigDto[];
  instanceId: string | null;
};

export const usePresetGlobalFiltersFromUrl = ({
  config,
  instanceId,
}: UsePresetGlobalFiltersFromUrlParams) => {
  const [filterInitialized, presetFilterSelectionValue, setFilterInitialized] =
    useStore(
      useShallow((state) => [
        state.filterInitialized,
        state.presetFilterSelectionValue,
        state.setFilterInitialized,
      ])
    );

  const filterKeys = useMemo(
    () =>
      (config ?? []).map((filterConfig) =>
        createGlobalFilterSearchParamKey(filterConfig.key)
      ),
    [config]
  );
  const filtersFromUrl = useSearchParamsByKeys(filterKeys);

  useEffect(() => {
    if (instanceId == null || filterInitialized[instanceId] === true) {
      return;
    }

    for (const filterConfig of config ?? []) {
      const filterValueFromUrl =
        filtersFromUrl[createGlobalFilterSearchParamKey(filterConfig.key)];
      presetSelectionFromUrl(
        presetFilterSelectionValue,
        instanceId,
        filterValueFromUrl,
        filterConfig
      );
    }

    setFilterInitialized(instanceId);
  }, [
    config,
    filterInitialized,
    filtersFromUrl,
    instanceId,
    presetFilterSelectionValue,
    setFilterInitialized,
  ]);
};
